export default "TBU";
export const searchBarRender = ["/dashboard"];
